export default __webpack_public_path__ + "static/media/banner-estimulos.596c52e6.jpeg";